


export const HIGHREST_TABS = [
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    }
]

export const ADMIN_TABS = [
    {
        title: "Uw Queue",
        key: "uw_queue",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Ca Queue",
        key: "ca_queue",
        order_id: 2
    },
    {
        title: "All Applications",
        key: "all_applications",
        order_id: 3
    },
    {
        title: "Funded",
        key: "funded",
        order_id: 4
    }
]



export const ADMIN_UNDERWRITTER_TABS = [
    {
        title: "Uw Queue",
        key: "uw_queue",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Ca Queue",
        key: "ca_queue",
        order_id: 2
    },
    {
        title: "All Applications",
        key: "all_applications",
        order_id: 3
    },
    {
        title: "Funded",
        key: "funded",
        order_id: 4
    }
]

export const SALES_TABS = [
    {
        title: "All Applications",
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Funded",
        key: "funded",
        order_id: 2
    }
]

export const ACCOUNT_TABS = [
    {
        title: "All Applications",
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Funded",
        key: "funded",
        order_id: 2
    }
]

export const LOAN_PROCESSOR_TABS = [
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Ca Queue",
        key: "ca_queue",
        order_id: 0
    },
    {
        title: "All Applications",
        key: "all_applications",
        order_id: 2
    },
    {
        title: "Funded",
        key: "funded",
        order_id: 3
    }
]


export const LOAN_PROCESSOR_READER_TABS = [
    {
        title: "Funded",
        key: "funded",
        order_id: 2
    }
]

export const UNDERWRITTER_TABS = [
    {
        title: "Uw Queue",
        key: "uw_queue",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 2
    },
    {
        title: "All Applications",
        key: "all_applications",
        order_id: 1
    },
    {
        title: "Ca Queue",
        key: "ca_queue",
        order_id: 4
    },
    {
        title: "Funded",
        key: "funded",
        order_id: 3
    }
]

export const CLOSER_TABS = [
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "All Applications",
        key: "all_applications",
        order_id: 1
    },
    {
        title: "Funded",
        key: "funded",
        order_id: 2
    }
]